import {postRequest} from "./apiService";
import {applicationRoute} from "../constants/routes";

export const sendApplication = (values: any) => {
    return postRequest(applicationRoute, values);
}